jQuery(document).ready(function() {

  jQuery('.update-qty-btn').click(function(){
    var qty = jQuery(this).siblings('.show-qty').val();
    var id = jQuery(this).attr('data-id');
    jQuery.ajax({
      url:'/cart/change.js',
      type: 'post',
      dataType: 'json',
      data: { quantity:qty, id:id },
      success: function(msg) {
        console.log(msg);
        location.reload();
      }
    });
  });

  
  jQuery(".cart-item__name").each(function(){
    if(jQuery(this).text() == 'Gift Wrap'){
      jQuery(".add-wrapping").addClass('is-checked');
      jQuery(this).parents('.cart-item').find('.cart-item__quantity-wrapper').hide();
    }
    if(jQuery(this).text() == 'Greeting Card'){
      jQuery(".add-card").addClass('is-checked');
      jQuery(this).parents('.cart-item').find('.cart-item__quantity-wrapper').hide();
    }
  });
  
  
  
  jQuery("body").on("click",".add-wrapping",function(){
    jQuery(this).toggleClass('is-checked');
    if(jQuery(this).hasClass('is-checked')){
      jQuery.ajax({
        url:'/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: { quantity:1, id:40029095002225 },
        success: function(msg) {
          console.log(msg);
          location.reload();
        }
      });
    }else{
      jQuery.ajax({
        url:'/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: { quantity:0, id:40029095002225 },
        success: function(msg) {
          console.log(msg);
          location.reload();
        }
      });
    }
  });
  jQuery("body").on("click",".add-card",function(){
    jQuery(this).toggleClass('is-checked');
    if(jQuery(this).hasClass('is-checked')){
      jQuery.ajax({
        url:'/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: { quantity:1, id:40029083009137 },
        success: function(msg) {
          console.log(msg);
          location.reload();
        }
      });
    }else{
      jQuery.ajax({
        url:'/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: { quantity:0, id:40029083009137 },
        success: function(msg) {
          console.log(msg);
          location.reload();
        }
      });
    }
  });
  
  
//     let formData = {
//       'items': [{
//         'id': '43126868738276',
//         'quantity': 1
//       }]
//     };

//     jQuery.ajax({
//       url:'/cart/add.js',
//       type: 'post',
//       dataType: 'json',
//       data: formData,
//       success: function(msg) {
//         console.log(msg);
//       }
//     });
  
	
	jQuery('.sort-tools ul li button').click(function() {
		jQuery('.first-wrap').addClass('loading');
		jQuery('.ajax-loaded-box').addClass('loading');
		jQuery(this).parent().siblings().removeClass('active');
		jQuery(this).parent().addClass('active');
		var sort = jQuery(this).text();
		jQuery('.sort-value').text(sort);
        if(jQuery('.filter-title').length){
          var col = jQuery('.search-box .tags span.active').attr('data-col');
        }else{
          var col = jQuery('.search-box .tags').attr('data-url');
        }
		var sort = jQuery(this).attr('data-sort');
		var ajaxURL = jQuery('.ajax-loaded-box').attr('data-base-url') + col + '?' + sort;
		console.log(ajaxURL);
		jQuery.ajax({
		  url: ajaxURL,
		  type: 'GET',
		  dataType: 'html',
		  success: function (responseHTML) {
			jQuery('.first-wrap').removeClass('loading');
			jQuery('.ajax-loaded-box').removeClass('loading');
			var content_1 = jQuery(responseHTML).find('.first-wrap').html();
			var content_2 = jQuery(responseHTML).find('.ajax-loaded-box').html();
			var newMax = jQuery(responseHTML).find('.ajax-loaded-box').attr('data-max-page');
			var page = jQuery(responseHTML).find('.ajax-loaded-box').attr('data-current-page');
			jQuery('.first-wrap').html(content_1);
			jQuery('.ajax-loaded-box').html(content_2);
			jQuery('.ajax-loaded-box').attr('data-max-page',newMax);
			if(page>=jQuery('.ajax-loaded-box').attr('data-max-page')){
				jQuery('.product-ajax-load-more').hide();
			}else{
				jQuery('.product-ajax-load-more').show();
			}
		  },
		  complete: function () {}
		});
    });
	
	jQuery('.search-box .tags span').click(function() {
		jQuery('.first-wrap').addClass('loading');
		jQuery('.ajax-loaded-box').addClass('loading');
		jQuery(this).siblings().removeClass('active');
		jQuery(this).addClass('active');
		var col = jQuery(this).attr('data-col');
        if(jQuery('.sort-tools').length){
          var sort = jQuery('.sort-tools ul li.active button').attr('data-sort');
          var ajaxURL = jQuery('.ajax-loaded-box').attr('data-base-url') + col + '?' + sort;
        }else{
          var ajaxURL = jQuery('.ajax-loaded-box').attr('data-base-url') + col;
        }
		
		
		console.log(ajaxURL);
		jQuery.ajax({
		  url: ajaxURL,
		  type: 'GET',
		  dataType: 'html',
		  success: function (responseHTML) {
			jQuery('.first-wrap').removeClass('loading');
			jQuery('.ajax-loaded-box').removeClass('loading');
			var content_1 = jQuery(responseHTML).find('.first-wrap').html();
			var content_2 = jQuery(responseHTML).find('.ajax-loaded-box').html();
			var newMax = jQuery(responseHTML).find('.ajax-loaded-box').attr('data-max-page');
			var page = jQuery(responseHTML).find('.ajax-loaded-box').attr('data-current-page');
			jQuery('.first-wrap').html(content_1);
			jQuery('.ajax-loaded-box').html(content_2);
			jQuery('.ajax-loaded-box').attr('data-max-page',newMax);
			if(page>=jQuery('.ajax-loaded-box').attr('data-max-page')){
				jQuery('.product-ajax-load-more').hide();
			}else{
				jQuery('.product-ajax-load-more').show();
			}
		  },
		  complete: function () {}
		});
    });
		
	jQuery('.product-ajax-load-more').click(function() {
		
		jQuery(this).addClass('loading');
		var page = parseInt(jQuery('.ajax-loaded-box').attr('data-current-page')) + 1;
		var col = jQuery('.search-box .tags span.active').attr('data-col');
		var sort = jQuery('.sort-tools ul li.active button').attr('data-sort');
		var ajaxURL = jQuery('.ajax-loaded-box').attr('data-base-url') + col + '?page=' + page + '&' + sort;
      console.log(ajaxURL);
		jQuery.ajax({
		  url: ajaxURL,
		  type: 'GET',
		  dataType: 'html',
		  success: function (responseHTML) {
			var content = jQuery(responseHTML).find('.ajax-loaded-box').html();
			jQuery('.ajax-loaded-box').append(content);
			jQuery('.ajax-loaded-box').attr('data-current-page',page);
			jQuery('.product-ajax-load-more').removeClass('loading');
			if(page>=jQuery('.ajax-loaded-box').attr('data-max-page')){
				jQuery('.product-ajax-load-more').hide();
			}else{
				jQuery('.product-ajax-load-more').show();
			}
		  },
		  complete: function () {}
		});
		
    });
	
	
		
	jQuery('.post-ajax-load-more').click(function() {
		jQuery(this).addClass('loading');
		var page = parseInt(jQuery('.ajax-loaded-box').attr('data-current-page')) + 1;
		var ajaxURL = jQuery('.ajax-loaded-box').attr('data-base-url') + jQuery('.ajax-loaded-box').attr('data-blog') + '?page=' + page;
		jQuery.ajax({
		  url: ajaxURL,
		  type: 'GET',
		  dataType: 'html',
		  success: function (responseHTML) {
			var content = jQuery(responseHTML).find('.ajax-loaded-box').html();
			jQuery('.ajax-loaded-box').append(content);
			jQuery('.ajax-loaded-box').attr('data-current-page',page);
			jQuery('.post-ajax-load-more').removeClass('loading');
			if(page>=jQuery('.ajax-loaded-box').attr('data-max-page')){
				jQuery('.post-ajax-load-more').remove();
			}
		  },
		  complete: function () {}
		});
    });
	
	
});
